module.exports = __webpack_public_path__ + "static/img/home_day.70787fd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icons/home_day.jpeg
// module id = /Oc4
// module chunks = 4